import { B_FLOW_ID, C_FLOW_ID, PL_FLOW_ID } from '../boilerplate/item-ids';

/**
 * Transformer that adds a new item to the shopping cart when the user
 * reaches a `summary` page. Also removes all items on `success` page
 * since the purchase is finished.
 */
export default (kasko) => {
  kasko.addEventListener('route-changed', ({ current }) => {
    if (current?.path.includes('success')) {
      kasko.dispatchEvent('set-state-input', {
        shopping_cart_items: [],
      });
    }
    if (!current?.path.includes('summary')) {
      return;
    }

    const quote = kasko.getState().quote.data;
    if (!quote) {
      return;
    }
    const items = [];
    const quoteData = quote.extraData;
    const inputState = kasko.getState().input;

    if (inputState.contents_finished) {
      items.push({
        title: 'flow.contents_item.title',
        cost: kasko.getTranslation('flow.contents_item.cost'),
        costValue: quoteData.yearly_content_insurance_gross_premium,
        id: C_FLOW_ID,
        color: 'blue',
        editScreen: 'summary',
      });
    }

    if (inputState.private_liability_finished) {
      items.push({
        title: 'flow.private_liability_item.title',
        cost: kasko.getTranslation('flow.private_liability_item.cost'),
        costValue: quoteData.yearly_private_liability_gross_premium,
        id: PL_FLOW_ID,
        color: 'orange',
        editScreen: 'private-liability-summary',
      });
    }

    if (inputState.buildings_finished) {
      items.push({
        title: 'flow.buildings_item.title',
        cost: kasko.getTranslation('flow.buildings_item.cost'),
        costValue: quoteData.yearly_building_gross_premium,
        id: B_FLOW_ID,
        color: 'red',
        editScreen: 'buildings-summary',
      });
    }

    kasko.dispatchEvent('write-input', {
      value: items,
      path: 'shopping_cart_items',
      overwrite: true,
    });
    kasko.dispatchEvent('write-input', {
      value: items.reduce((acc, item) => acc + (item.costValue || 0), 0),
      path: 'shopping_cart_items_total_cost',
      overwrite: true,
    });
  });
};
